import success from '../../../assets/images/successIcon.svg';
import { closePopup } from '../../../store/slices/popupSlice';
import { useAppDispatch } from '../../../store/store';
import styles from './styles/styles.module.css';

function OrderSuccessPopup() {
  const dispatch = useAppDispatch();

  const handleClosePopup = () => {
    dispatch(closePopup());
  };

  return (
    <div className={styles.orderSuccessPopupWrapper}>
      <button
        className={styles.closePopupButton}
        onClick={handleClosePopup}
        aria-label="Закрыть"
      />
      <div className={styles.orderSuccessTextWrapper}>
        <img src={success} alt="иконка успех" />
        <h2 className={styles.orderSuccessTitle}>Заказ успешно обновлен!</h2>
        <h3 className={styles.orderSuccessSubTitle}>
          Данные заказа успешно изменены и переданы на склад
        </h3>
      </div>
    </div>
  );
}

export default OrderSuccessPopup;
